import { render } from "./CustomerInput.vue?vue&type=template&id=eaaaca38"
import script from "./CustomerInput.vue?vue&type=script&lang=js"
export * from "./CustomerInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__